var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg23 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.1 91",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "23")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.06,7.52H44.11c-4.37,5-18,21.7-24.49,42.07-7,21.92,10.86,33.37,25,33.85v0a1.71,1.71,0,0,0,.39,0l.42,0v0c14.23-.48,32-11.93,25-33.85C64.08,29.23,50.45,12.53,46.06,7.52Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg23, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/23.04302834.svg";
export { ForwardRef as ReactComponent };